import React, { Component } from 'react';

class Hamburger extends Component {
    render() {
        return (
            <a href="javascript://" {...this.props} className="hamburger u-unstyled" aria-label="Toggle menu">
                <span className="hamburger__filling"></span>
            </a>
        );
    }
}

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/Global/Hamburger.js